<template>
  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
      <b-row>
        <b-col cols="12 headerF"><HeaderFixed/></b-col>
        <b-col cols="12 headerM"><HeaderMobile/></b-col>
      </b-row>

      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item>
                <router-link to="/ActsAndRules">
                  Acts & Policies
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="#" active>Supply Code</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <h1 class="heading">Supply Code</h1>
          </b-col>
        </b-row>

        <div class="paddingLeft30px">
          <div id="ConsDetails" style="width:90vw;font-size:0.8rem">
            <br>
            <b-table :items="supplyCode" :fields="SupplyCodeFields" show-empty empty-text="No documents found">
              <template v-slot:cell(name)="data">
                <span class="doc-cell" v-html="data.value"></span>
              </template>
            </b-table>
          </div>
          <br><br>
        </div>
      </b-container>

      <br><br>
    </b-overlay>
  </div>
</template>


<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import axios from 'axios'

export default {
  name: 'SupplyCode',
  components: {
    HeaderFixed,
    HeaderMobile
  },

  data() {
    return {
      SupplyCodeFields: [
        { key: 'name', label: 'Particulars', thStyle: { width: '80vw' } }
      ],
      supplyCode: [],
      show: false
    }
  },

  mounted() {
    this.show = true;
    axios.get(this.$urlCommon + "/api/web/document")
      .then((response) => {
        const data = response.data.document || [];

        this.supplyCode = data
          .filter(el => Number(el.sub_type) === 53)
          .map(el => ({
            name: "<a class='doc-link' href='" + this.$urlCommon + "/" + encodeURI(el.file_location) +
                  "' target='_blank'><img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' " +
                  "height='30px' width='30px' style='margin-left: -7px;' />" + el.name + "</a>"
          }));
      })
      .catch((error) => {
        console.error("Document fetch failed:", error);
      })
      .finally(() => {
        this.show = false;
      });
  }
}
</script>


<style scoped>
li {
  padding: 0;
}

body {
  overflow-y: hidden;
}

.heading {
  border-left: 10px solid #ed7c27;
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}

table {
  text-align: left !important;
}


.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }
  .headerM {
    display: block;
  }
  .paddingLeft30px {
    padding-left: 0px;
  }
}

@media only screen and (max-width: 414px) {
  .paddingLeft30px {
    padding-left: 0px;
  }
}
</style>

<!-- Not scoped: the links come from v-html, which scoped styles can't reach -->
<style>
.doc-cell a {
  transition: color 0.2s;
}

.doc-cell a:hover {
  color: #ed7c27 !important;
}
</style>